import { useCallback, useState } from 'react';

import { defaultLimit } from 'views/CRM/shared/utils/pagination';

import ProductService from '../services/productService';

export const useListProducts = ({ recordTypeId }) => {
  const [products, setProducts] = useState(null);
  const [totalProducts, setTotalProducts] = useState(0);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);

  const getProducts = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingProducts(true);

      ProductService.getProducts(recordTypeId, params, {
        page,
        limit: defaultLimit
      })
        .then((response) => {
          setProducts(response.data.data);
          setTotalProducts(response.data.totalRegisters);
        })
        .finally(() => setIsLoadingProducts(false));
    },
    [recordTypeId]
  );

  const clearProducts = useCallback(() => {
    setProducts(null);
    setTotalProducts(0);
    setIsLoadingProducts(false);
  }, []);

  return {
    products,
    totalProducts,
    isLoadingProducts,
    getProducts,
    clearProducts
  };
};
